
declare const $;
export function count_down_timer_directive() {
    "ngInject";

    var directive = {
        link: link,
        restrict: 'A',
        scope:{
            countDownTimer:"="
        }
    };
    return directive;

    function link(scope, element, attrs) {
        CountDown(scope.countDownTimer)
        function CountDown(time) {

            let thisEl = $(element);

            function time_number(number) {
                var time_list = "<ul><li>0</li><li>1</li><li>2</li><li>3</li><li>4</li><li>5</li><li>6</li><li>7</li><li>8</li><li>9</li></ul>";
                for (let i = 0; i < number - 1; i++) {
                    time_list = time_list + "<ul><li>0</li><li>1</li><li>2</li><li>3</li><li>4</li><li>5</li><li>6</li><li>7</li><li>8</li><li>9</li></ul>";
                }
                return time_list;
            }

            var days_nub = 1;
            var hours_nub = 2;
            var minutes_nub = 2;
            var seconds_nub = 2;

            thisEl.find(".hours").html(time_number(hours_nub));
            thisEl.find(".minutes").html(time_number(minutes_nub));
            thisEl.find(".seconds").html(time_number(seconds_nub));

            clearInterval(interval);

            function countdown_proc() {



                var seconds = time;

                let days: any = Math.floor(seconds / (60 * 60 * 24));
                seconds -= days * 60 * 60 * 24;
                let hours: any = Math.floor(seconds / (60 * 60));
                seconds -= hours * 60 * 60;
                let minutes: any = Math.floor(seconds / 60);
                seconds -= minutes * 60;

                days = (String(days).length >= 2) ? days : "0" + days;
                hours = (String(hours).length >= 2) ? hours : "0" + hours;
                minutes = (String(minutes).length >= 2) ? minutes : "0" + minutes;
                seconds = (String(seconds).length >= 2) ? seconds : "0" + seconds

                if (time < 0) {

                    seconds = "00";
                    minutes = "00";
                    hours = "00";
                    clearInterval(interval);
                }
                let seconds_array = String(seconds).split("");
                let minutes_array = String(minutes).split("");
                let hours_array = String(hours).split("");



                if (hours_array.length > hours_nub) {
                    thisEl.find(".hours").html(time_number(hours_array.length));
                    hours_nub = hours_array.length;
                }
                if (minutes_array.length > minutes_nub) {
                    thisEl.find(".minutes").html(time_number(minutes_array.length));
                    minutes_nub = minutes_array.length;
                }
                if (seconds_array.length > seconds_nub) {
                    thisEl.find(".seconds").html(time_number(seconds_array.length));
                    seconds_nub = seconds_array.length;
                }

                function time_add(name, name_array) {
                    for (let i = 0; i < name_array.length; i++) {
                        thisEl.find("." + name + " > ul:eq(" + i + ")").find("li").eq(name_array[i]).addClass("selected").siblings("li").removeClass("selected");
                        var time_sixnub;
                        if (name == "days") {
                            time_sixnub = 9;
                        } else {
                            time_sixnub = i == 0 ? 6 : 9;
                        }
                        thisEl.find("." + name + " > ul:eq(" + i + ")").find("li").eq(parseInt(name_array[i]) + 1 > time_sixnub ? 0 : parseInt(name_array[i]) + 1).addClass("prepare").siblings("li").removeClass("prepare");
                    }
                };

                time_add('seconds', seconds_array);
                time_add('hours', hours_array);
                time_add('minutes', minutes_array);



                time = time - 1;
            }
            countdown_proc();
            var interval = setInterval(countdown_proc, 1000)
        }
    }
}


function ControllerController() {

}



// WEBPACK FOOTER //
// ./src/directives/count-down-timer/count-down-timer.ts